import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Row, Col } from 'antd';

import './CompanyModules.style.less';

class CompanyModules extends PureComponent {
  renderItem = module => {
    const { colSpan } = this.props;

    return (
      <Col span={colSpan} key={module.id} className="company-modules-col">
        <Checkbox
          key={module.name}
          checked={module.checked}
          disabled={module.disabled}
          onChange={event => {
            this.props.onSelectModule(module, event.target.checked);
          }}
        >
          {module.name}
        </Checkbox>
      </Col>
    );
  };

  renderItems = () => {
    const { availableModules } = this.props;
    const filteredModules = availableModules.filter(x => !x.hidden);

    const result = [];
    if (filteredModules.length > 0) {
      for (let i = 0; i < filteredModules.length; i += 1) {
        result.push(this.renderItem(filteredModules[i]));
      }

      return result;
    }

    return (
      <Col span={24} className="placeholder">
        {this.props.placeholder}
      </Col>
    );
  };

  render() {
    return (
      <Row className="company-modules-container">{this.renderItems()}</Row>
    );
  }
}

CompanyModules.propTypes = {
  onSelectModule: PropTypes.func,
  availableModules: PropTypes.array,
  colSpan: PropTypes.number,
  placeholder: PropTypes.string,
};

CompanyModules.defaultProps = {
  colSpan: 12,
  placeholder: 'No data available',
};

export default CompanyModules;
